/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Iris Design Limited  Fulfilment POD base styles
import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Iris Design Limited  Fulfilment POD helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { white } = colors;
const { borderRadius } = borders;

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(250),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: {
      width: pxToRem(250),
      backgroundColor: white.main,
      height: `calc(100vh - ${pxToRem(32)})`,
      margin: pxToRem(16),
      borderRadius: borderRadius.xl,
      border: "none",
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;
